export default __webpack_public_path__ + "static/media/arbitiumLogoNoText.44c429fd.png";